import type { ReactNode } from "react";
import type { Tone } from "../lib/formatters";

interface BadgeProps {
  tone?: Tone;
  size?: "sm" | "md";
  children: ReactNode;
}

/** A small status pill, in the warm tones the semantics are painted with. */
export function Badge({ tone = "neutral", size = "md", children }: BadgeProps) {
  return <span className={`ui-badge ui-badge-${tone} ui-badge-${size}`}>{children}</span>;
}
